import React, { Component } from "react";
import { getSingle } from "../../services/projectService";
import {
  getAll,
  deleteSingl,
  getAllDocumentsFiltered,
} from "../../services/projectDocumentService";
import {
  saveSingle,
  getAllLedgers,
  deleteLedger,
} from "../../services/projectLedgerService";

import {
  Table,
  Grid,
  Icon,
  Confirm,
  Button,
  Message,
  Statistic,
} from "semantic-ui-react";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import { Link } from "react-router-dom";
import Pagination from "../common/pagination";
import { paginate } from "../../utils/paginate";
import TableTitle from "../common/tableTitle";
import Form from "../common/form";
import Joi from "joi-browser";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import _ from "lodash";
import SearchTextBox from "../common/searchTextBox";
import LedgerProjectNetBalance from "../common/ledgerprojectnetbalance";
import ReactToPrint from "react-to-print";
import auth from "../../services/authService";
import queryString from "query-string";

class ProjectDetail extends Form {
  state = {
    imageUrl: false,
    visa: {},
    open: false,
    paymentDate: new Date(),
    documents: [],
    roomId: "",
    data: {
      description: "",
      daily_hour: "",
      rate: "",
      //amount: "",
      material_expense: "",
      running_invoices: "",
      debit: "",
      credit: "",
    },
    errors: {},
    payments: [],
    pageSize: 5000,
    currentPage: 1,
    keyFieldValue: "",
    sortColumn: { path: "sort_date", order: "asc" },
    debit: 0,
    credit: 0,
    balance: 0,
    ledgerTypeName: "",
    companyId: "",
    totalDailyHours: "",
    totalAmount: "",
    totalMaterialExpense: "",
    totalExpense: "",
    totalDebit: "",
    totalCredit: "",
    totalReceiveableAmount: "",
    totalRunningInvoices: "",
    startDate: "",
    endDate: "",
    startDateDoc: "",
    endDateDoc: "",
  };

  schema = {
    id: Joi.string(),
    description: Joi.string().required().label("Description"),
    daily_hour: Joi.number().required().label("Daily Hours"),
    rate: Joi.number().required().label("Rate"),
    //amount: Joi.number().required().label("Amount"),
    material_expense: Joi.number().required().label("Material Expense"),
    running_invoices: Joi.label("Running Invoices"),
    debit: Joi.label("Debit"),
    credit: Joi.label("Credit"),
  };

  async getVisaDetail(roomId) {
    try {
      this.setState({ blocking: true });

      const { data: visa } = await getSingle(roomId, this.state.companyId);

      this.setState({ roomId: roomId, visa, blocking: false });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  async componentDidMount() {
    const roomId = this.props.match.params.id;

    await this.getVisaDetail(roomId);

    localStorage.setItem("roomId", roomId);

    const { data: documents } = await getAll(roomId, this.state.companyId);
    this.setState({ documents });

    const verifyData = {
      startDate: "",
      endDate: "",
    };

    const { data: payments } = await getAllLedgers(verifyData);

    this.statistics(payments.data);

    this.setState({
      blocking: false,
      payments: payments.data,
      totalDailyHours: payments.totalDailyHours,
      totalAmount: payments.totalAmount,
      totalMaterialExpense: payments.totalMaterialExpense,
      totalExpense: payments.totalExpense,
      totalDebit: payments.totalDebit,
      totalCredit: payments.totalCredit,
      totalRunningInvoices: payments.totalRunningInvoices,
      totalReceiveableAmount: payments.totalReceiveableAmount,
    });
  }

  statistics = (data) => {
    let debit = 0;
    let credit = 0;
    let balance = 0;

    data.map((trans) => {
      trans.totalCredit > 0
        ? (credit = credit + parseInt(trans.credit))
        : (debit = debit + parseInt(trans.debit));
    });

    balance = credit - debit;

    this.setState({ debit, credit, balance });
  };

  handleDeleteLedger = (type) => {
    this.setState({ openLedger: true, type });
  };

  doDeleteLedger = async () => {
    const type = this.state.type;
    const originalTypes = this.state.payments;
    const payments = originalTypes.filter((o) => o.id !== type.id);
    this.setState({ payments, openLedger: false });

    try {
      await deleteLedger(type.id);

      toast.success("Ledger has been deleted successfully.");
    } catch (ex) {
      if (ex.response && ex.response.status === 404) {
        toast.success("This Ledger has already been deleted.");
      }

      this.setState({ types: originalTypes });
    }
  };

  handleUpdateLedger = (type) => {
    return this.props.history.replace("/projects-ledgers/" + type.id + "/edit");
  };

  handleDelete = (type) => {
    this.setState({ open: true, type });
  };

  handleUpdate = (type) => {
    return this.props.history.replace(
      "/projects-documents/" + type.id + "/edit"
    );
  };

  handleCancel = () => {
    this.setState({ open: false });
  };

  handleCancelLedger = () => {
    this.setState({ openLedger: false });
  };

  handleChangePaymentDate = (date) => {
    this.setState({
      paymentDate: date,
    });
  };

  updateLedgerType = (ledgerType) => {
    this.setState({ ledgerType });
  };

  doSubmit = async () => {
    try {
      this.setState({ blocking: true });
      //const data = { ...this.state.data };

      let formData = new FormData();
      formData.append("description", this.state.data.description);
      formData.append("daily_hour", this.state.data.daily_hour);
      formData.append("rate", this.state.data.rate);
      formData.append("material_expense", this.state.data.material_expense);
      formData.append("running_invoices", this.state.data.running_invoices);
      formData.append("debit", this.state.data.debit);
      formData.append("credit", this.state.data.credit);

      formData.append("attachment", this.state.imageUrl);
      formData.append("project_cost_id", localStorage.getItem("ledgerId"));

      // var event = new Date(this.state.paymentDate);
      // let date = JSON.stringify(event);
      // date = date.slice(1, 11);
      // data.payment_date = date;78

      var event = new Date(this.state.paymentDate);
      let date = JSON.stringify(event);
      date = date.slice(1, 11);
      formData.append("payment_date", date);

      await saveSingle(formData);

      const verifyData = {
        startDate: "",
        endDate: "",
      };

      //const { data: payments } = await getAllLedgers(verifyData);

      toast.success("Cost has been added successfully.");
      this.setState({
        blocking: false,
        data: {
          description: "",
          daily_hour: "",
          rate: "",
          //amount: "",
          material_expense: "",
          running_invoices: "",
          debit: "",
          credit: "",
        },
        imageUrl: false,
      });
      window.location =
        "/projects-accounts/view/" + localStorage.getItem("roomId");
      // this.props.history.push(
      //   "/projects-accounts/view/" + localStorage.getItem("roomId")
      // );
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.payment)
          errors.payment = ex.response.data.errors.payment;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  handleSort = (sortColumn) => {
    this.setState({ sortColumn });
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  getPagedData = () => {
    const {
      pageSize,
      currentPage,
      payments: allPayments,
      keyFieldValue,
      sortColumn,
    } = this.state;

    let filtered = allPayments;
    filtered = keyFieldValue
      ? filtered.filter(
          (m) =>
            m.description.toUpperCase().indexOf(keyFieldValue.toUpperCase()) >
            -1
        )
      : filtered;

    const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);

    const payments = paginate(sorted, currentPage, pageSize);
    return { totalCount: filtered.length, data: payments };
  };

  handleSearching = async (keyword, searchType) => {
    if (searchType == "document") {
      try {
        this.setState({ blocking: true });

        const { data: documents } = await getAllDocumentsFiltered(
          localStorage.getItem("roomId"),
          keyword
        );

        this.setState({
          blocking: false,
          documents,
        });
      } catch (ex) {
        if (ex.response && ex.response.status === 422) {
          const errors = { ...this.state.errors };

          if (ex.response.data.errors.name)
            errors.name = ex.response.data.errors.name;

          this.setState({ errors, blocking: false });
          //toast.warning("check validation errors.");
        }
      }
    } else {
      this.setState({ keyFieldValue: keyword, currentPage: 1 });
    }
  };

  formatBalance = () => {
    let fBalance;
    let balance;
    balance = (this.state.totalRunningInvoices - this.state.totalDebit).toFixed(
      2
    );
    balance = balance.toString();
    if (balance < 0) {
      fBalance = "(" + balance.replace("-", "") + ")";
      return fBalance;
    }
    return balance;
  };

  formatExpense = () => {
    let exp;
    exp = parseFloat(this.state.totalExpense).toFixed(2);
    return exp;
  };

  handleChangeStartDate = (date) => {
    this.setState({
      startDate: date,
    });
  };

  handleChangeEndDate = (date) => {
    this.setState({
      endDate: date,
    });
  };

  handleChangeStartDateDoc = (date) => {
    this.setState({
      startDateDoc: date,
    });
  };

  handleChangeEndDateDoc = (date) => {
    this.setState({
      endDateDoc: date,
    });
  };

  doReset = async () => {
    const verifyData = {
      startDate: "",
      endDate: "",
    };
    this.setState({ startDate: "", endDate: "" });

    const { data: payments } = await getAllLedgers(verifyData);

    this.statistics(payments.data);

    this.setState({
      blocking: false,
      payments: payments.data,
      totalDailyHours: payments.totalDailyHours,
      totalAmount: payments.totalAmount,
      totalMaterialExpense: payments.totalMaterialExpense,
      totalExpense: payments.totalExpense,
      totalDebit: payments.totalDebit,
      totalCredit: payments.totalCredit,
      totalRunningInvoices: payments.totalRunningInvoices,
      totalReceiveableAmount: payments.totalReceiveableAmount,
    });
  };

  doFilterPaymentsData = async () => {
    try {
      var event = new Date(this.state.startDate);
      event.setDate(event.getDate() + 1);
      let startDate = JSON.stringify(event);
      startDate = startDate.slice(1, 11);

      event = new Date(this.state.endDate);
      event.setDate(event.getDate() + 1);
      let endDate = JSON.stringify(event);
      endDate = endDate.slice(1, 11);

      this.setState({ blocking: true });

      const verifyData = {
        startDate: startDate,
        endDate: endDate,
      };

      const { data: payments } = await getAllLedgers(verifyData);

      this.statistics(payments.data);

      this.setState({
        blocking: false,
        payments: payments.data,
        totalDailyHours: payments.totalDailyHours,
        totalAmount: payments.totalAmount,
        totalMaterialExpense: payments.totalMaterialExpense,
        totalExpense: payments.totalExpense,
        totalDebit: payments.totalDebit,
        totalCredit: payments.totalCredit,
        totalRunningInvoices: payments.totalRunningInvoices,
        totalReceiveableAmount: payments.totalReceiveableAmount,
      });
    } catch (ex) {
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  onChangeFile = (e) => {
    let files = e.target.files || e.dataTransfer.files;
    if (!files.length) return;
    this.setState({ imageUrl: files[0] });
    //this.createImage(files[0]);
  };
  render() {
    const { visa } = this.state;
    const { pageSize, currentPage, sortColumn } = this.state;
    const { totalCount, data: payments } = this.getPagedData();
    const url =
      "/projects-accounts/" + localStorage.getItem("roomId") + "/document/new/";

    const { keyword, status } = queryString.parse(this.props.location.search);

    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <Confirm
          open={this.state.openLedger}
          header="Confirmation"
          content="Are you sure, you want to delete the ledger?"
          onCancel={this.handleCancelLedger}
          onConfirm={this.doDeleteLedger}
          size="mini"
        />

        <h1 className="container__heading">Project Account Detail</h1>

        <Link
          to={`/projects-accounts?keyword=${keyword}&status=${status}`}
          className="btn btn--secondary account-detail-page-btn"
        >
          Back
        </Link>

        <section className="grid grid--1x4 detail-basic-info">
          <div className="detail-basic-info__unit">
            <div className="detail-basic-info__unit-heading">
              Client / Company Name
            </div>
            <div className="detail-basic-info__unit-value">
              {visa.company_name}
            </div>
          </div>
          <div className="detail-basic-info__unit">
            <div className="detail-basic-info__unit-heading">Project Name</div>
            <div className="detail-basic-info__unit-value">
              {visa.project_name}
            </div>
          </div>

          <div className="detail-basic-info__unit">
            <div className="detail-basic-info__unit-heading">Mobile/Tel </div>
            <div className="detail-basic-info__unit-value">
              {visa.mobile_tel}
            </div>
          </div>
          <div className="detail-basic-info__unit">
            <div className="detail-basic-info__unit-heading">Ref Date</div>
            <div className="detail-basic-info__unit-value">{visa.ref_date}</div>
          </div>
          <div className="detail-basic-info__unit">
            <div className="detail-basic-info__unit-heading">Email</div>
            <div className="detail-basic-info__unit-value">{visa.email}</div>
          </div>
          <div className="detail-basic-info__unit">
            <div className="detail-basic-info__unit-heading">Project Code</div>
            <div className="detail-basic-info__unit-value">
              {visa.project_code}
            </div>
          </div>
          <div className="detail-basic-info__unit">
            <div className="detail-basic-info__unit-heading">Work Order</div>
            <div className="detail-basic-info__unit-value">
              {visa.work_order}
            </div>
          </div>
          <div className="detail-basic-info__unit">
            <div className="detail-basic-info__unit-heading">TRN</div>
            <div className="detail-basic-info__unit-value">{visa.trn}</div>
          </div>
          <div className="detail-basic-info__unit">
            <div className="detail-basic-info__unit-heading">
              Consultant Name
            </div>
            <div className="detail-basic-info__unit-value">
              {visa.consultant_name}
            </div>
          </div>
          <div className="detail-basic-info__unit">
            <div className="detail-basic-info__unit-heading">
              Consultant Email
            </div>
            <div className="detail-basic-info__unit-value">
              {visa.consultant_email}
            </div>
          </div>
          <div className="detail-basic-info__unit">
            <div className="detail-basic-info__unit-heading">
              Consultant Phone1
            </div>
            <div className="detail-basic-info__unit-value">
              {visa.consultant_phone1}
            </div>
          </div>
          <div className="detail-basic-info__unit">
            <div className="detail-basic-info__unit-heading">
              Consultant Phone2
            </div>
            <div className="detail-basic-info__unit-value">
              {visa.consultant_phone2}
            </div>
          </div>
        </section>

        <h1 className="container__heading account-detail-page-title">
          Documents
        </h1>

        <Link to={url} className="btn btn--primary account-detail-page-btn">
          New Document
        </Link>

        <div className="grid account-detail-page-simple-filters">
          <SearchTextBox
            onSearchButtonClick={this.handleSearching}
            type="document"
          />
        </div>
        <div style={{ height: "300px", overflow: "auto" }}>
          <Table celled fixed singleLine className="account-detail-page-table">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell width={6}>Name</Table.HeaderCell>
                <Table.HeaderCell width={2}>Attachment Type</Table.HeaderCell>
                <Table.HeaderCell width={2}>
                  Attachment
                  <br />
                  <small>Use mouse right click to download the file.</small>
                </Table.HeaderCell>
                <Table.HeaderCell width={2}>Renewal Date</Table.HeaderCell>
                <Table.HeaderCell width={2}>Expiry Date</Table.HeaderCell>
                <Table.HeaderCell width={2}></Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {this.state.documents.map((document) => (
                <Table.Row key={document.id}>
                  <Table.Cell>{document.name}</Table.Cell>

                  <Table.Cell>{document.type}</Table.Cell>
                  <Table.Cell>
                    {document.attachment != "" ? (
                      <a
                        target="_blank"
                        href={
                          process.env.REACT_APP_BACKEND_URL +
                          "/storage/" +
                          document.attachment
                        }
                      >
                        Download
                      </a>
                    ) : (
                      "N / A"
                    )}
                  </Table.Cell>
                  <Table.Cell>
                    {document.type === "complex"
                      ? document.renewal_date
                      : "N/A"}
                  </Table.Cell>
                  <Table.Cell>
                    {document.type === "complex" ? document.expiry_date : "N/A"}
                  </Table.Cell>
                  <Table.Cell>
                    {auth.getCurrentUser().email ===
                      "client-unblocker@gondalgroup.ae" && (
                      <div>
                        <Icon
                          name="trash"
                          color="red"
                          className="clickable"
                          onClick={() => this.handleDelete(document)}
                        />

                        <Icon
                          name="edit"
                          color="blue"
                          className="clickable"
                          onClick={() => this.handleUpdate(document)}
                        />

                        {/* <Icon
                          name="print"
                          color="blue"
                          className="clickable"
                          onClick={() => this.handlePrint(document)}
                        /> */}
                      </div>
                    )}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
        <h1 className="container__heading account-detail-page-title">
          Project Account Ledgers
        </h1>

        <div className="grid grid--1x4 account-detail-page-stats">
          <span className="icon-container account-detail-page-stats__icon">
            <span className="dashboard-accounts-stats__label">
              {this.formatExpense()}
            </span>
            <span className="dashboard-accounts-stats__heading account-detail-page-stats__label">
              Expense
            </span>
          </span>
          <span className="icon-container account-detail-page-stats__icon">
            <span className="dashboard-accounts-stats__label">
              {this.state.totalDebit}
            </span>
            <span className="dashboard-accounts-stats__heading account-detail-page-stats__label">
              Debit
            </span>
          </span>
          <span className="icon-container account-detail-page-stats__icon">
            <span className="dashboard-accounts-stats__label">
              {this.state.totalRunningInvoices}
            </span>
            <span className="dashboard-accounts-stats__heading account-detail-page-stats__label">
              Credit
            </span>
          </span>

          <span className="icon-container account-detail-page-stats__icon">
            <span className="dashboard-accounts-stats__label">
              {" "}
              {this.formatBalance()}
            </span>
            <span className="dashboard-accounts-stats__heading account-detail-page-stats__label">
              Balance
            </span>
          </span>
        </div>

        <div className="grid account-detail-page-filters">
          <DatePicker
            selected={this.state.startDate}
            onChange={this.handleChangeStartDate}
            placeholderText="Select Start Date"
            className="input"
          />
          <div></div>
          <DatePicker
            selected={this.state.endDate}
            onChange={this.handleChangeEndDate}
            className="input"
            placeholderText="Select End Date"
          />
          <div></div>
          <button
            className="btn btn--primary"
            onClick={this.doFilterPaymentsData}
          >
            Submit
          </button>
          <div></div>
          <button className="btn btn--secondary" onClick={this.doReset}>
            Reset
          </button>
        </div>

        <div className="grid account-detail-page-simple-filters">
          <SearchTextBox
            onSearchButtonClick={this.handleSearching}
            type="ledger"
          />
        </div>

        <div className="ui error form" style={{ width: "60%" }}>
          <Message
            negative
            style={{
              display: this.state.showError == true ? "block" : "none",
            }}
          >
            <Message.Header>Error</Message.Header>
            <p>Data not found for the dates specified.</p>
          </Message>
        </div>

        <div className="scrap-report">
          <div className="scrap-report__print">
            <ReactToPrint
              trigger={() => <a href="#">Print this out!</a>}
              content={() => this.componentRef}
            />
          </div>

          <LedgerProjectNetBalance
            visa={visa}
            totalDailyHours={this.state.totalDailyHours}
            totalAmount={this.state.totalAmount}
            totalMaterialExpense={this.state.totalMaterialExpense}
            totalExpense={this.state.totalExpense}
            totalDebit={this.state.totalDebit}
            totalCredit={this.state.totalCredit}
            totalReceiveableAmount={this.state.totalReceiveableAmount}
            totalRunningInvoices={this.state.totalRunningInvoices}
            visaid={this.state.roomId}
            payments={payments}
            onDelete={this.handleDeleteLedger}
            onUpdate={this.handleUpdateLedger}
            ref={(el) => (this.componentRef = el)}
          />
        </div>

        <center>
          <form
            onSubmit={this.handleSubmit}
            className="ui error form"
            style={{ width: "50%", marginTop: "2rem" }}
          >
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell colSpan="2">Add Cost</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {/* <Table.Row>
                      <Table.Cell width="16" colSpan="2">
                        <Button.Group>
                          {this.state.ledgerTypes.map((type) => (
                            <React.Fragment>
                              <Button
                                positive={
                                  this.state.ledgerTypeName === type.id
                                    ? true
                                    : false
                                }
                                onClick={() => this.updateLedgerType(type.id)}
                              >
                                {type.name}
                              </Button>
                            </React.Fragment>
                          ))}
                          ;
                        </Button.Group>
                      </Table.Cell>
                    </Table.Row> */}

                <Table.Row>
                  <Table.Cell width="16" colSpan="2">
                    {this.renderInput("description", "Description", "text")}
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="8">
                    <label>
                      <b>Date</b>
                    </label>
                    <br />
                    <DatePicker
                      style={{ width: "200px" }}
                      selected={this.state.paymentDate}
                      onChange={this.handleChangePaymentDate}
                    />
                  </Table.Cell>
                  <Table.Cell width="8">
                    {this.renderInput("daily_hour", "Daily Hours", "text")}
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="8">
                    {this.renderInput("rate", "Rate", "text")}
                  </Table.Cell>
                  <Table.Cell width="8">
                    {/* {this.renderInput("amount", "Amount", "text")} */}
                    {this.renderInput("material_expense", "Expense", "text")}
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="8">
                    {this.renderInput(
                      "running_invoices",
                      "Running Invoices",
                      "text"
                    )}
                  </Table.Cell>
                  <Table.Cell width="8">
                    {this.renderInput("debit", "Debit", "text")}
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="8">
                    {this.renderInput("credit", "Credit", "text")}
                  </Table.Cell>
                  <Table.Cell width="8">
                    <label>
                      <b>Attachment</b>
                    </label>
                    <input
                      className="input_imagem_artigo"
                      type="file"
                      onChange={this.onChangeFile}
                    />
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell>{this.renderButton("Add")}</Table.Cell>
                  <Table.Cell></Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
            <br />
            <br />
          </form>
        </center>
      </BlockUi>
    );
  }
}

export default ProjectDetail;
